import React, { useState, useCallback, useContext, useEffect } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { PlayerUIContext, dragSeekingEnded, dragSeekingStarted } from '@24i/player-ui';
import { SeekingContainer } from '../../styled';
const PERCENT = 100;
export const SeekingManager = ({ parentElement, onSeekingProgress, onSeekingStart, onSeekingEnd, onHoverStart, onHoverEnd, isSeekingDisabled, }) => {
    const [isGestureInProgress, setIsGestureInProgress] = useState(false);
    const [isHovering, setIsHovering] = useState(false);
    const { dispatch } = useContext(PlayerUIContext);
    const getAndReportProgress = useCallback(({ pageX }) => {
        if (!parentElement || pageX === undefined)
            return;
        const { left, width } = parentElement.getBoundingClientRect();
        const progress = ((pageX - left) / width) * PERCENT;
        const progressInPercent = Math.max(0, Math.min(PERCENT, progress));
        onSeekingProgress(progressInPercent);
    }, [parentElement, onSeekingProgress]);
    const preventEvent = useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
    }, []);
    const onGestureStarted = useCallback(() => {
        setIsGestureInProgress(true);
        onSeekingStart();
        dispatch(dragSeekingStarted());
    }, [setIsGestureInProgress, onSeekingStart]);
    const onGestureEnded = useCallback(() => {
        setIsGestureInProgress(false);
        onSeekingEnd();
        dispatch(dragSeekingEnded());
    }, [onSeekingEnd, setIsGestureInProgress]);
    const onMouseDown = useCallback((event) => {
        if (isSeekingDisabled)
            return;
        preventEvent(event);
        onGestureStarted();
        getAndReportProgress(event);
    }, [preventEvent, onGestureStarted, getAndReportProgress, isSeekingDisabled]);
    const onMouseMove = useCallback((event) => {
        if (isGestureInProgress || isHovering) {
            preventEvent(event);
            getAndReportProgress(event);
        }
    }, [isGestureInProgress, isHovering, preventEvent, getAndReportProgress]);
    const onMouseUp = useCallback((event) => {
        if (isGestureInProgress)
            preventEvent(event);
    }, [isGestureInProgress, preventEvent]);
    const onClick = useCallback((event) => {
        if (isGestureInProgress) {
            preventEvent(event);
            onGestureEnded();
        }
    }, [isGestureInProgress, preventEvent, onGestureEnded]);
    const onMouseEnter = useCallback((event) => {
        if (isSeekingDisabled)
            return;
        setIsHovering(true);
        onHoverStart();
        getAndReportProgress(event);
    }, [onHoverStart, getAndReportProgress, isSeekingDisabled]);
    const onMouseLeave = useCallback(() => {
        setIsHovering(false);
        onHoverEnd();
    }, [onHoverEnd]);
    useEffect(() => {
        if (isSeekingDisabled) {
            if (isHovering)
                onMouseLeave();
            if (isGestureInProgress)
                onGestureEnded();
        }
    }, [isSeekingDisabled]);
    useEventListener('mousemove', onMouseMove, window);
    useEventListener('mouseup', onMouseUp, window);
    useEventListener('click', onClick, window);
    return (React.createElement(SeekingContainer, { "data-test": "SeekingManager-Container", onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, isGestureInProgress }));
};
//# sourceMappingURL=index.js.map